var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _c(
        "transition",
        { attrs: { name: "fade", mode: "out-in" } },
        [_vm.isRouterAlive ? _c("router-view", { ref: "Navview" }) : _vm._e()],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.dialogVisible,
            width: "50%",
            "close-on-click-modal": _vm.closeOnClickModal,
            "close-on-press-escape": _vm.closeOnPressEscape,
            "show-close": _vm.showClose,
            center: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "upgradee" },
            [
              _c("el-progress", {
                attrs: {
                  status: "success",
                  "text-inside": true,
                  "stroke-width": 20,
                  percentage: _vm.percentage,
                  width: _vm.strokeWidth,
                  "show-text": true,
                },
              }),
            ],
            1
          ),
          _c("div", {
            staticClass: "upgrade-content",
            domProps: { innerHTML: _vm._s(_vm.content) },
          }),
        ]
      ),
      _c("canvas", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: false,
            expression: "false",
          },
        ],
        attrs: { id: "base64CanvasRegion", width: "460", height: "400" },
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.loginModelStatus,
            top: "30vh",
            "custom-class": "login-modal",
          },
          on: { close: _vm.closeLoginModel },
        },
        [
          _c(
            "div",
            {
              staticClass: "login-msg-title",
              attrs: { slot: "title" },
              slot: "title",
            },
            [
              _c("img", {
                attrs: {
                  src: "//storage.360buyimg.com/jdcp-web/Image/message3.png",
                  alt: "",
                },
              }),
              _c("div", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.$t("loginFailure"))),
              ]),
            ]
          ),
          _c("div", { staticClass: "login-content" }, [
            _c("div", { staticClass: "loginMessageContentDesc1" }, [
              _vm._v(_vm._s(_vm.$t("loginFailureTips"))),
            ]),
            _c("div", { staticClass: "loginMessageContentDesc2" }, [
              _c("img", {
                attrs: {
                  src: "//storage.360buyimg.com/jdcp-web/Image/message1.png",
                  alt: "",
                },
              }),
              _vm._v(" " + _vm._s(_vm.$t("loginStep1")) + " "),
              _c(
                "span",
                { staticClass: "link", on: { click: _vm.jumpLogin } },
                [_c("u", [_vm._v(" " + _vm._s(_vm.$t("loginStep1-1")))])]
              ),
              _vm._v(" " + _vm._s(_vm.$t("loginStep1-2")) + " "),
            ]),
            _c("div", { staticClass: "loginMessageContentDesc3" }, [
              _c("img", {
                attrs: {
                  src: "//storage.360buyimg.com/jdcp-web/Image/message2.png",
                  alt: "",
                },
              }),
              _vm._v(" " + _vm._s(_vm.$t("loginStep2")) + " "),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }